import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { MadFragment, MAD_FRAGMENT } from "../../fragments";
import { InsertMadMutationVariables } from "../../types";

export const INSERT_MAD = gql`
  mutation insertMad($input: InsertMadInput!) {
    insertMad(input: $input) {
      mad {
        ...MadFragment
      }
    }
  }
  ${MAD_FRAGMENT}
`;

export type MadData = { insertMad: { mad: MadFragment } };

export default (
  options?: MutationHookOptions<MadData, InsertMadMutationVariables>
) => {
  return useMutation<MadData, InsertMadMutationVariables>(INSERT_MAD, options);
};
